export default __webpack_public_path__ + "static/media/Goldschopfpinguin.c3e35fb0.jpg";